import React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import classnames from "classnames";
import { useTheme } from "react-jss";
import useStyles from "./InputBox.styles";
import { FontAwesomeIcon } from "./FontAwesome";
import InputWrapper from "./InputWrapper";

interface Props {
    focused?: boolean;
    freeform?: boolean;
    size?: string;
    leftLabel?: string;
    rightLabel?: string;
    className?: string;
    style?: any;
    accessoryLeft?: IconProp;
    accessoryRight?: IconProp;
    children: unknown;
}

export default function InputBox(props: Props) {
    const {
        focused,
        children,
        className,
        accessoryLeft,
        accessoryRight,
        size,
        leftLabel,
        rightLabel,
    } = props;
    const theme = useTheme();
    const classes = useStyles({ ...props, theme });
    return (
        <InputWrapper size={size} leftLabel={leftLabel} rightLabel={rightLabel}>
            <div
                className={classnames(
                    classes.inputBox,
                    focused && classes.inputBoxFocused,
                    className,
                )}
            >
                {accessoryLeft && (
                    <FontAwesomeIcon
                        icon={accessoryLeft}
                        className={classnames(
                            classes.inputBoxAccessory,
                            classes.inputBoxAccessoryLeft,
                        )}
                    />
                )}
                {children}
                {accessoryRight && (
                    <FontAwesomeIcon
                        icon={accessoryRight}
                        className={classnames(
                            classes.inputBoxAccessory,
                            classes.inputBoxAccessoryRight,
                        )}
                    />
                )}
            </div>
        </InputWrapper>
    );
}
